import { HealthNavigatorResponse } from './navigator'
import { Consultation, CONSULTATION_STATUS, CONSULTATION_STEPS } from './consultation'

export enum WebSocketState {
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3
}

export const CASE_STATUS_STEP: Record<CONSULTATION_STATUS, CONSULTATION_STEPS> = {
  [CONSULTATION_STATUS.SUBMITTED]: CONSULTATION_STEPS.MATCHING,
  [CONSULTATION_STATUS.OPEN]: CONSULTATION_STEPS.MATCHING,
  [CONSULTATION_STATUS.CLAIMED]: CONSULTATION_STEPS.MATCH,
  [CONSULTATION_STATUS.RESOLVED]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.WAITING_FOR_RATING]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.CANCELED]: CONSULTATION_STEPS.LANDING,
  [CONSULTATION_STATUS.CLOSED]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.NEW]: CONSULTATION_STEPS.LANDING,
  [CONSULTATION_STATUS.CLOSED_WORATING]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.ONGOING_VIDEO_CALL]: CONSULTATION_STEPS.ONGOING_VIDEO_CALL,
  [CONSULTATION_STATUS.VIDEO_CALL_ENDED]: CONSULTATION_STEPS.VIDEO_CALL_ENDED,
  [CONSULTATION_STATUS.WAITING_FOR_INFO]: CONSULTATION_STEPS.WAITING_FOR_INFO,
  [CONSULTATION_STATUS.WAITING_FOR_SWAP]: CONSULTATION_STEPS.WAITING_FOR_SWAP,
  [CONSULTATION_STATUS.WAITING_FOR_CONSULTATION_PAYMENT]: CONSULTATION_STEPS.WAITING_FOR_CONSULTATION_PAYMENT,

  [CONSULTATION_STATUS.CLOSED_WITH_REPORT_ACCESS]: CONSULTATION_STEPS.ANSWER,
  [CONSULTATION_STATUS.REPORT_ACCESS_EXPIRED]: CONSULTATION_STEPS.LANDING
}

export enum WEBSOCKET_ACTION {
  CONSULTATION_UPDATED = 'consultationUpdated',
  PDF_UPDATED = 'pdfUpdated',
  HEALTH_NAVIGATOR_UPDATED = 'healthNavigatorUpdated'
}

export interface WebsocketMessage {
  consultation?: Consultation
  navigator?: HealthNavigatorResponse
  connectionId: string
  action: WEBSOCKET_ACTION
}

export enum WebsocketModal {
  DISCONNECT = 'DISCONNECT',
  ALREADY_CONNECTED = 'ALREADY_CONNECTED'
}
